import '../css/app.css';
// Must be evaluated before the Inertia app starts (its popstate listener has to run first)
import './lib/overlay-history';

import { createInertiaApp } from '@inertiajs/react';
import axios from 'axios';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import posthog from 'posthog-js';
import { createRoot } from 'react-dom/client';
import { Toaster as SonnerToaster } from 'sonner';
import { ImpersonationBanner } from './components/impersonation-banner';
import { Toaster } from './components/ui/toaster';
import { CRMProvider } from './contexts/CRMContext';
import { initializeTheme } from './hooks/use-appearance';
import { attachPostHogCorrelationHeaders } from './lib/posthog-correlation-headers';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

if (import.meta.env.VITE_POSTHOG_KEY) {
    posthog.init(import.meta.env.VITE_POSTHOG_KEY as string, {
        api_host: import.meta.env.VITE_POSTHOG_HOST as string,
        person_profiles: 'identified_only',
        capture_pageview: true,
        capture_pageleave: true,
        session_recording: {
            recordHeaders: false,
            recordBody: false,
        },
    });

    axios.interceptors.request.use((config) => attachPostHogCorrelationHeaders(config));
}

createInertiaApp({
    title: (title) => (title ? `${title} - ${appName}` : appName),
    resolve: (name) => resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx')),
    setup({ el, App, props }) {
        const user = (props.initialPage.props as Record<string, unknown> & { auth?: { user?: { id: number; name: string; email: string } } }).auth
            ?.user;
        if (user && import.meta.env.VITE_POSTHOG_KEY) {
            posthog.identify(String(user.id), { name: user.name, email: user.email });
        }

        const root = createRoot(el);

        root.render(
            <CRMProvider>
                <ImpersonationBanner />
                <App {...props} />
                <Toaster />
                <SonnerToaster position="top-right" richColors closeButton />
            </CRMProvider>,
        );
    },
    progress: {
        color: '#4B5563',
    },
});

initializeTheme();
